<template>
  <div class="px-1 md:px-0">
    <slot />
    <PWAInstallPrompt />
    <PWAUpdatePrompt />
  </div>
</template>

<script>
import PWAInstallPrompt from '@/components/PWAInstallPrompt'
import PWAUpdatePrompt from '@/components/PWAUpdatePrompt'

export default {
  name: 'Auth',
  components: {
    PWAInstallPrompt,
    PWAUpdatePrompt,
  },
}
</script>
